import { render, staticRenderFns } from "./CatalogueList.vue?vue&type=template&id=b04af6aa&scoped=true&"
import script from "./CatalogueList.vue?vue&type=script&lang=js&"
export * from "./CatalogueList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04af6aa",
  null
  
)

export default component.exports